/**
 * Node Modules
 */
import React, {createElement, useState, useEffect} from 'react'
import { Helmet } from 'react-helmet'
import { graphql, Link } from 'gatsby'
import marksy from 'marksy/jsx'

/**
 * Application Modules
 */
import './style.css'
import '../../components/styles/buttons.css'
import '../../components/contact-form/style.css'
import PageContainer from '../../components/page-container'
import Footer from '../../components/footer'
import Section from '../../components/section'
import Header from '../../components/header'
import DownloadBanner from '../../components/download-banner'
import Metadata from '../../components/metadata'
import Spacer from "../../components/spacer";
import {CopyPrimaryDiv, HeroTertiary, HeroPrimary, CopyPrimary, CopySecondaryDiv} from "../../components/typography";
import { LineIcon } from 'react-share'

const compile = marksy({createElement})

function Hero ({hed, dek, url, alt, messages}) {
  const styles = {
    '--logo-color': 'var(--purple)',
    '--color': 'var(--light-purple)',
    '--active-color': 'var(--coral)',
    '--background-color': 'var(--white)',
  }

  return (
    <Section className="help-center-hero" styles={styles} >
      <Spacer size={[50, 100]} />
      <div className="help-center-hero__copy grid">
        <HeroPrimary className="text-center help-center-hero__hed column-start-1 column-start-2--t column-start-3--d column-end-6 column-end-11--t column-end-10--d">{hed}</HeroPrimary>
        <Spacer className="column-start-1 column-end-6" size={[10, 40]} />
        <CopyPrimary className="text-center help-center-hero__dek column-start-1 column-start-2--t column-start-3--d column-end-6 column-end-11--t column-end-10--d">{dek}</CopyPrimary>
        <Spacer className="column-start-1 column-end-6" size={[40, 80]} />
      </div>

      <div className="help-center-hero__chat grid flex flex-center">

        <div className="column-start-1 column-end-6 column-end-12--t help-center-hero__chat-layout">
          <div className="help-center-hero__chat-portrait">
            <div className="flex flex-center">
              <img  className="help-center-hero__chat-portrait-img" src={url} alt={alt} />
            </div>
            <Spacer size={[0, 44]} />
            <div className="flex flex-center">
              <a href="#live-chat" className="help-center-hero__live-chat button button--yellow">Live Chat</a>
            </div>
          </div>

          <div className="help-center-hero__chat-message-group">
            {compile(messages).tree}
            <Spacer size={[24, 200]} />
            <div>
             <a href="#live-chat" className="help-center-hero__live-chat button button--yellow">Live Chat</a>
            </div>
          </div>
        </div>
      </div>
      <Spacer size={[65, 100]} id={"contact"} />
    </Section>
  )
}

function ContactForm ({hed, dek, name, message, under13Message, cta}) {
  const [isChild, setIsChild] = useState(true)

  return (
    <Section className='help-center-contact-form contact-form'>
      <Helmet>
        <meta name="referrer" content="origin" />
      </Helmet>
      <div className="contact-form__grid grid">
        <div className="contact-form__content column-start-1 column-start-2--t  column-start-3--d column-end-6 column-end-11--t column-end-10--d">

          <HeroTertiary className="text-center">{hed}</HeroTertiary>
          <Spacer size={[10, 40]} />
          <CopySecondaryDiv className="text-center">{compile(dek).tree}</CopySecondaryDiv>
          <Spacer size={[20, 40]} />
          <form action="https://formspree.io/hello@kinzoo.com" method="POST">
            <input type="hidden" name="_subject" value="Website Contact Form" />
            <div className="contact-form__age-radio-group flex flex-center">
              <span>Age:</span>
              <label><input className="contact-form__radio" checked={isChild ? 'checked' : ''} onChange={() => {setIsChild(true)}} name="age-check" value="under 13" type='radio'/><span>under 13</span></label>
              <label><input className="contact-form__radio" checked={!isChild ? 'checked' : ''} onChange={() => {setIsChild(false)}} name="age-check" value="13 and older" type='radio'/><span>13 and older</span></label>
            </div>
            <Spacer size={[20, 30]} />
            {!isChild && <>
              <input className="contact-form__input reset" type="text" name="name" placeholder={name} />
              <Spacer size={[20, 30]} />
              <input className="contact-form__input reset" type="text" name="_replyto" placeholder="Email address"/>
              <Spacer size={[20, 30]} />
            </>}
            {isChild && <>
              <input className="contact-form__input reset" type="hidden" name="name" value="Child under 13" />
              <input className="contact-form__input reset" type="hidden" name="_replyto" value="no-reply@kinzoo.com"/>{/* Zendesk+formspree requires an email */}
            </>}
            <div className="contact-form__textarea-group">
              <textarea className="contact-form__textarea reset" name="message" placeholder={isChild ? under13Message: message } />
              <Link className="contact-form__privacy-policy contact-form__privacy-policy--not-mobile" to="/privacy-policy">Privacy Policy</Link>
            </div>
            <Spacer size={[10, 20]} />
            <div className="flex flex-center">
              <input className='button contact-form__submit reset' type="submit" value={cta} />
            </div>
            <Spacer size={[10, 0]} />
            <Link className="contact-form__privacy-policy contact-form__privacy-policy--mobile" to="/privacy-policy">Privacy Policy</Link>
            <Spacer id="faq" size={[80, 200]} />
          </form>
        </div>
      </div>
    </Section>
  )
}

function Faq({hed, dek, faqs}) {
  const [openItems, setOpenItems] = useState(new Array(faqs.length).fill(false))
  return (
    <div className="help-center__faq" >
      <div className="help-center__faq-copy grid">
        <HeroTertiary className="text-center column-start-1 column-start-2--t column-start-3--d column-end-6 column-end-11--t column-end-10--d">{hed}</HeroTertiary>
        <Spacer className="column-start-1 column-end-6" size={[0, 40]} />
        <CopyPrimaryDiv className="text-center column-start-1 column-start-2--t column-start-3--d column-end-6 column-end-11--t column-end-10--d">{compile(dek).tree}</CopyPrimaryDiv>
        <Spacer className="column-start-1 column-end-6" size={[24, 40]} />
      </div>
      <div className="help-center__question-group grid">

        {faqs.map((faq, i) => (
          <div key={'faq' + i}  className={`help-center__question  ${openItems[i] ? 'open' : 'closed'} column-start-1 column-start-2--t column-start-3--d column-end-6 column-end-11--t column-end-10--d`}>
            <h3 className="help-center__question-title">
              <button className="reset" onClick={(e) => {
                e.preventDefault();
                let newState = [...openItems]
                newState[i] = !newState[i]
                setOpenItems(newState)
            }}>
              {faq.title}
            </button>
            </h3>
            <Spacer size={[16, 24]} />
            <div className="help-center__question-copy">
              {compile(faq.markdown.markdown).tree}
            </div>
          </div>
        ))}
      </div>
      <Spacer size={[64, 100]} />
    </div>
  )
}

/**
 * Page Component
 */
export default function Page({ data }) {
  const { referencePageMetadata } = data.contentfulSingletonHelpCenter
  const { hed, dek } = data.contentfulSingletonHelpCenter
  const { chatBubbles, chatProfilePhoto } = data.contentfulSingletonHelpCenter
  const { contactHed, contactDek, contactNamePlaceholder, contactMessagePlaceholder, contactMessageUnder13Placeholder, contactCta } = data.contentfulSingletonHelpCenter
  const { faqHed, faqDek, referenceQuestionsGroups } = data.contentfulSingletonHelpCenter

  const styles = {
    '--logo-color': 'var(--purple)',
    '--color': 'var(--light-purple)',
    '--active-color': 'var(--coral)',
    '--background-color': 'var(--white)',
  }

  useEffect(() => {
    function openChat(e) {
      if (!!e.target && e.target.hash === '#live-chat') {
        e.preventDefault();
        $zopim.livechat.window.show()
      }
    }

    document.addEventListener('click', openChat);

    return () => {
      document.removeEventListener('click', openChat);
    };
  });

  return (
    <PageContainer>
      <Helmet>
        <link rel="canonical" href="https://kinzoo.com/help-center/" />
        <meta property="og:url" content="https://kinzoo.com/help-center/" />
      </Helmet>
      <Metadata {...referencePageMetadata} />
      <Header styles={styles} />
      <Hero hed={hed} dek={dek.dek}
            url={chatProfilePhoto.file.url}
            alt={chatProfilePhoto.alt}
            messages={chatBubbles.chatBubbles}
      />

      <ContactForm
        hed={contactHed}
        dek={contactDek.contactDek}
        name={contactNamePlaceholder}
        message={contactMessagePlaceholder}
        under13Message={contactMessageUnder13Placeholder}
        cta={contactCta}
      />

      <Faq hed={faqHed} dek={faqDek.faqDek} faqs={referenceQuestionsGroups} />
      <DownloadBanner />
      <Footer />
    </PageContainer>
  )
}

export const pageQuery = graphql`
  query HelpCenterQuery {
    contentfulSingletonHelpCenter(contentful_id: { eq: "joxcQ2iaPRAJo0fG0DNXM" }) {
      hed
      dek {
        dek
      }
      
      chatProfilePhoto {
        title
        file {
          url
        }
      }
      chatBubbles {
        chatBubbles
      }
      
      contactHed
      contactDek {
        contactDek
      }
      contactNamePlaceholder
      contactMessagePlaceholder
      contactMessageUnder13Placeholder
      contactCta
      
      faqHed
      faqDek {
        faqDek
      }
      referenceQuestionsGroups {
        title
        markdown {
          markdown
        }
      }

      
      referencePageMetadata {
        pageTitle
        ogTitle
        twitterTitle
        description
        ogDescription
        twitterDescription
        ogImage {
          file {
            url
          }
        }
        twitterImage {
          file {
            url
          }
        }
      }
    }
  }
`
